module.exports = __webpack_public_path__ + "img/tree-04-h-leaves.ae067609.png";